module.exports = __webpack_public_path__ + "static/img/course.1ea2a88c.png";